// service.ts
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  getData(): Observable<any[]> {
    // Aquí es donde obtendrías los datos reales, probablemente con un HttpClient.get()
    return of([
      { date: new Date('2022-04-01'), count: 80 },
      { date: new Date('2022-04-02'), count: 55 },
      { date: new Date('2022-04-03'), count: 20 },
      { date: new Date('2022-04-04'), count: 56 },
      { date: new Date('2022-04-05'), count: 96 },
      { date: new Date('2022-04-06'), count: 120 },
      { date: new Date('2022-04-07'), count: 140 },
      { date: new Date('2022-04-08'), count: 45 },
      { date: new Date('2022-04-09'), count: 62 },
      { date: new Date('2022-04-10'), count: 180 },
      { date: new Date('2022-04-11'), count:  200},
      { date: new Date('2022-04-12'), count: 90 },
      { date: new Date('2022-04-13'), count: 70 },
      { date: new Date('2022-04-14'), count: 75 },
      { date: new Date('2022-04-15'), count: 80 },
      { date: new Date('2022-04-16'), count: 85 },
      { date: new Date('2022-04-17'), count: 67 },
      { date: new Date('2022-04-18'), count: 44 },
      { date: new Date('2022-04-19'), count: 51 },
      { date: new Date('2022-04-20'), count: 105 },
      { date: new Date('2022-04-21'), count: 110 },
      { date: new Date('2022-04-22'), count: 115 },
      { date: new Date('2022-04-23'), count: 120 },
      { date: new Date('2022-04-24'), count: 88 },
      { date: new Date('2022-04-25'), count: 220 },
      { date: new Date('2022-04-26'), count: 135 },
      { date: new Date('2022-04-27'), count: 140 },
      { date: new Date('2022-04-28'), count: 58 },
      // ...
    ]);
  }
}


